type tabProps = {
  tabs: {
    value: string;
    label: string;
    labelMobile?: string;
  }[];
  onChange: (value: string) => void;
  selectedTab: string;
};

const Tab = ({ tabs, onChange, selectedTab }: tabProps) => {
  return (
    <div className="tabs">
      {tabs.map(({ value, label, labelMobile }) => (
        <button
          className={`tabs__item ${
            value === selectedTab ? `tabs__item_active` : ''
          }`}
          key={value}
          data-label={labelMobile}
          onClick={() => onChange(value)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default Tab;
